import logoNoronCar from '../Images/logo.png'
import InsuranceShow from './InsuranceShow'
import config from "../config.json";
import loginLogo from '../Images/logoWeb.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import AddImage from '../Images/AddImage.png'
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from './ConfirmDialog'
//import form1 from '../Images/form1.jpg'
import form2 from '../Images/form2.jpg'

export default function RequestInsurance() {
    let navigate = useNavigate();

    const backgroundCardMeli = useRef(null);
    const picCardMeli = useRef(null);

    const backgroundPersoneli = useRef(null);
    const picPersoneli = useRef(null);

    const [form, setForm] = useState({ id: 0, name: "", family: "", detail: [] })
    const [ozveSetting, setOzveSetting] = useState({ vam: "" })
    const [isLoadingSetting, setIsLoadingSetting] = useState(false)
    const getSetting = async () => {
        setIsLoadingSetting(true);
        await service.SettingGet()
            .then(({ data }) => {
                setIsLoadingSetting(false);
                /*if (data.errorCode != 0) {
                  toast.error(data.message, { theme: "colored" });
                  return
                }*/
                setOzveSetting(data);
            })
            .catch(err => {
                setIsLoadingSetting(false);
            });
    }

    const [isLoading, setIsLoading] = useState(false)
    const [dataUser, setDataUser] = useState({ id: 0, name: "", family: "" })
    const loadData = async () => {
        setIsLoading(true);
        await service.OzveGet()
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setDataUser(data.payload);
                setForm({
                    ...form,
                    name: data.payload.name,
                    family: data.payload.family,
                    nameFather: data.payload.nameFather,
                    code: data.payload.code,
                    codeMeli: data.payload.codeMeli,
                    birthDay: data.payload.birthDay,
                    mostamariCode: data.payload.mostamariCode,
                })
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        getSetting();
        loadData();
    }, []);

    const upload = (e, background, name) => {
        const { files } = e.target;
        if (files.length === 0) {
            return;
        }
        if (background) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                //style={{ backgroundImage: `url(${travelDetailPic})` }}            
                background.current.style.backgroundImage = `url(${fileReader.result})`;
            };
            fileReader.readAsDataURL(files[0]);
        }
        setForm({ ...form, [name]: e.target.files[0] })
    }

    const formRef = useRef(null);
    const form2Ref = useRef(null)
    const [showModal, setShowModal] = useState(false)
    const [formDetail, setFormDetail] = useState({})
    const addDetail = (e) => {
        e.preventDefault();
        setFormDetail({});
        setShowModal(true);
    }

    const doAddDetail = (e) => {
        e.preventDefault();
        const forms = form2Ref.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        const temp = { ...form };
        temp.detail = [...temp.detail, formDetail];
        setForm(temp);
        setFormDetail({});
        setShowModal(false);
    }

    const doDeleteDetailItem = (e, item, index) => {
        const temp = { ...form };
        temp.detail = temp.detail.filter((x, i) => i != index);
        setForm(temp);
    }

    const [isPosting, setIsPosting] = useState(false)
    const doPostFinall = async (e) => {
        e.preventDefault();
        setIsPosting(true);
        await service.RequestInsurance(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                //toast.dark('درخواست شما ثبت شد');
                //navigate('/main');
                toast.dark('لطفا تا انتقال به درگاه بانک شکیبا باشید');
                window.location = data.payload;
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
    useEffect(() => {
        //console.log('form', form)
    }, [form]);

    const [showInsurance, setShowInsurance] = useState(false);
    const [isPreview, setIsPreview] = useState(false)
    const doPreview = async (e) => {
        e.preventDefault();
        setIsPreview(true);
        await service.ReportInsurance(form)
            .then(({ data }) => {
                setIsPreview(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                
                let link = document.createElement("a");
                link.setAttribute("href", config.apiUrl + '/' + data.payload);
                link.setAttribute("target", "_blank");
                link.setAttribute("download", data);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => {
                setIsPreview(false);
            });
    }

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <ConfirmDialog
                show={showInsurance}
                size="lg"
                title="📋 لیست بیمه"
                //  handleDo={ }
                handleCancel={(e) => setShowInsurance(false)}
            >
                {showInsurance && <InsuranceShow />}
            </ConfirmDialog>

            <ConfirmDialog
                show={showModal}
                title="➕ ثبت اطلاعات فرد تحت تکفل"
                handleDo={doAddDetail}
                handleCancel={(e) => setShowModal(false)}
                // isBusy={ }
            >
                <form ref={form2Ref} className="needs-validation p-2" noValidate>
                    <div className="row g-3 text-start">
                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">👤 نام</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="مثلاً: علی"
                                required
                                value={formDetail.name || ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="name" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">👥 نام خانوادگی</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="مثلاً: محمدی"
                                required
                                value={formDetail.family || ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="family" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">👴 نام پدر</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="نام پدر"
                                required
                                value={formDetail.fatherName || ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="fatherName" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">🔢 شماره شناسنامه</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="شماره شناسنامه"
                                value={formDetail.code || ""}
                                required
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="code" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">🪪 کد ملی</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="۱۰ رقم کد ملی"
                                required
                                value={formDetail.codeMeli || ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="codeMeli" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">🏛️ محل صدور</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="شهر محل صدور"
                                required
                                value={formDetail.placeBirthName || ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="placeBirthName" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">📅 تاریخ تولد</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="مثلاً: ۱۳۵۰/۰۱/۰۱"
                                value={formDetail.birthDay || ""}
                                required
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="birthDay" 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label small fw-semibold text-secondary">🤝 نسبت با بیمه شده</label>
                            <select
                                className="form-select"
                                required
                                value={formDetail.nesbat ?? ""}
                                onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                name="nesbat" 
                            >
                                <option value="">انتخاب کنید...</option>
                                <option value={0}>مادر</option>
                                <option value={1}>پدر</option>
                                <option value={2}>فرزند</option>
                                <option value={3}>همسر</option>
                                <option value={4}>سایر</option>
                            </select>
                        </div>
                    </div>
                </form>
            </ConfirmDialog>

            <div className="container" style={{ maxWidth: '980px' }}>
                {/* هدر صفحه و لوگو */}
                <div className="text-center mb-4">
                    <img 
                        src={loginLogo} 
                        className="img-fluid mb-2" 
                        alt="لوگو کانون" 
                        style={{ maxHeight: '75px', objectFit: 'contain' }}
                    />
                    <h1 className="h4 fw-bold text-dark mb-1">
                        🛡️ کانون بازنشستگان همدان
                    </h1>
                    <p className="text-muted small mb-0">درخواست و ثبت‌نام خدمات بیمه تکمیلی و افراد تحت تکفل</p>

                    {(isLoadingSetting || isLoading) && (
                        <div className="d-flex align-items-center justify-content-center gap-2 mt-3 text-primary">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span className="small fw-semibold">در حال دریافت اطلاعات...</span>
                        </div>
                    )}
                </div>

                {/* کارت اصلی */}
                <div className="card shadow-sm border-0 rounded-4 overflow-hidden mb-4">
                    {/* بخش اعلان و حق بیمه */}
                    {!isLoadingSetting && (
                        <div className="p-3 p-md-4 border-bottom bg-primary bg-opacity-10">
                            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                                <div>
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <span className="fs-5" aria-hidden="true">📢</span>
                                        <h2 className="h6 fw-bold text-primary mb-0">اطلاعیه حق بیمه</h2>
                                    </div>
                                    <p className="text-dark mb-0 small">
                                        مبلغ حق بیمه به ازای هر نفر: <span className="fw-bold fs-6 text-primary">{ozveSetting.priceBimeh || '۰'} ریال</span> می‌باشد.
                                    </p>
                                </div>
                                <button
                                    onClick={e => { e.preventDefault(); setShowInsurance(true) }}
                                    className="btn btn-outline-primary btn-sm px-3 py-2 rounded-pill d-inline-flex align-items-center gap-2 shadow-sm"
                                >
                                    <span>📜</span>
                                    <span>مشاهده سابقه بیمه</span>
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="card-body p-3 p-md-4">
                        {/* فرم بیمه شده اصلی */}
                        <form ref={formRef} className="needs-validation" noValidate>
                            <div className="d-flex align-items-center justify-content-between border-bottom pb-2 mb-3">
                                <h3 className="h6 fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                                    <span>👤</span>
                                    <span>مشخصات بیمه شده اصلی</span>
                                </h3>
                                <button
                                    type="button"
                                    disabled={isPreview}
                                    onClick={doPreview}
                                    className="btn btn-outline-secondary btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-2 shadow-sm"
                                >
                                    {isPreview ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span>در حال آماده‌سازی...</span>
                                        </>
                                    ) : (
                                        <>
                                            <span>🖨️</span>
                                            <span>چاپ اطلاعات</span>
                                        </>
                                    )}
                                </button>
                            </div>

                            <div className="row g-3">
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">نام</label>
                                    <input 
                                        disabled
                                        type="text"
                                        className="form-control bg-light"
                                        value={form.name || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="name" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">نام خانوادگی</label>
                                    <input 
                                        disabled
                                        type="text"
                                        className="form-control bg-light"
                                        value={form.family || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="family" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">نام پدر</label>
                                    <input 
                                        disabled
                                        type="text"
                                        className="form-control bg-light"
                                        value={form.nameFather || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="nameFather" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">شماره شناسنامه</label>
                                    <input 
                                        disabled
                                        type="number"
                                        className="form-control bg-light font-monospace"
                                        value={form.code || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="code" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">کد ملی</label>
                                    <input 
                                        disabled
                                        type="number"
                                        className="form-control bg-light font-monospace"
                                        value={form.codeMeli || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="codeMeli" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">تاریخ تولد</label>
                                    <input 
                                        disabled
                                        type="text"
                                        className="form-control bg-light font-monospace"
                                        value={form.birthDay || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="birthDay" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">شماره مستمری</label>
                                    <input 
                                        disabled
                                        type="number"
                                        className="form-control bg-light font-monospace"
                                        value={form.mostamariCode || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mostamariCode" 
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">
                                        شماره شبا <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light text-muted small">IR</span>
                                        <input
                                            type="text"
                                            className="form-control text-start font-monospace"
                                            placeholder="۲۴ رقم شبا بدون IR"
                                            required
                                            value={form.shaba || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="shaba" 
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-lg-4">
                                    <label className="form-label small fw-semibold text-secondary">
                                        شعبه کانون <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="نام شعبه مربوطه"
                                        required
                                        value={form.shobeh || ""}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="shobeh" 
                                    />
                                </div>
                            </div>

                            {/* بخش بارگذاری و دانلود فرم‌ها */}
                            <div className="row g-3 mt-2 pt-3 border-top">
                                {/* فرم ۱ */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 border rounded-3 p-3 bg-light text-center">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="fw-semibold small text-dark">📄 مدرک / تصویر فرم ۱</span>
                                            {/*<a href={form1} download="form1">دانلود فرم 1</a>*/}
                                        </div>
                                        <div
                                            className="border border-2 border-dashed rounded-3 p-3 d-flex flex-column align-items-center justify-content-center bg-white cursor-pointer"
                                            style={{ 
                                                minHeight: "130px", 
                                                backgroundSize: "cover", 
                                                backgroundPosition: "center",
                                                cursor: "pointer" 
                                            }}
                                            ref={backgroundPersoneli}
                                            onClick={() => picPersoneli.current?.click()}
                                        >
                                            <input
                                                accept="image/*"
                                                className="d-none"
                                                type="file"
                                                onChange={(e) => { upload(e, backgroundPersoneli, "form1") }}
                                                ref={picPersoneli}
                                            />
                                            <Link
                                                to=""
                                                className="text-decoration-none"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picPersoneli.current?.click();
                                                }}
                                            >
                                                <img src={AddImage} alt="افزودن تصویر فرم 1" style={{ width: "42px", height: "42px" }} />
                                            </Link>
                                            <span className="small text-muted mt-2">جهت آپلود تصویر فرم ۱ کلیک کنید</span>
                                        </div>
                                    </div>
                                </div>

                                {/* فرم ۲ */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 border rounded-3 p-3 bg-light text-center">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="fw-semibold small text-dark">📄 مدرک / تصویر فرم ۲</span>
                                            <a href={form2} download="form2" className="btn btn-outline-secondary btn-sm py-0 px-2 rounded-pill small text-decoration-none">
                                                ⬇️ دانلود فرم ۲
                                            </a>
                                        </div>
                                        <div
                                            className="border border-2 border-dashed rounded-3 p-3 d-flex flex-column align-items-center justify-content-center bg-white cursor-pointer"
                                            style={{ 
                                                minHeight: "130px", 
                                                backgroundSize: "cover", 
                                                backgroundPosition: "center",
                                                cursor: "pointer" 
                                            }}
                                            ref={backgroundCardMeli}
                                            onClick={() => picCardMeli.current?.click()}
                                        >
                                            <input
                                                accept="image/*"
                                                className="d-none"
                                                type="file"
                                                onChange={(e) => { upload(e, backgroundCardMeli, "form2") }}
                                                ref={picCardMeli}
                                            />
                                            <Link
                                                to=""
                                                className="text-decoration-none"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picCardMeli.current?.click();
                                                }}
                                            >
                                                <img src={AddImage} alt="افزودن تصویر فرم 2" style={{ width: "42px", height: "42px" }} />
                                            </Link>
                                            <span className="small text-muted mt-2">جهت آپلود تصویر فرم ۲ کلیک کنید</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        {/* بخش افراد تحت تکفل */}
                        <div className="mt-5 pt-3 border-top">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div>
                                    <h3 className="h6 fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                                        <span>👨‍👩‍👧‍👦</span>
                                        <span>لیست افراد تحت تکفل</span>
                                    </h3>
                                    <span className="text-muted small">تعداد افزوده شده: {form.detail?.length || 0} نفر</span>
                                </div>
                                <button
                                    type="button"
                                    onClick={addDetail}
                                    className="btn btn-primary btn-sm rounded-pill px-3 py-2 d-inline-flex align-items-center gap-1 shadow-sm"
                                >
                                    <span>➕</span>
                                    <span>افزودن فرد جدید</span>
                                </button>
                            </div>

                            {form.detail && form.detail.length > 0 ? (
                                <div className="d-flex flex-column gap-3">
                                    {form.detail.map((x, i) => (
                                        <div className="card border rounded-3 p-3 bg-light shadow-sm" key={'r' + i}>
                                            <div className="d-flex align-items-center justify-content-between border-bottom pb-2 mb-3">
                                                <span className="badge bg-secondary rounded-pill px-3 py-2">
                                                    نفر شماره {i + 1}: {x.name} {x.family}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-1"
                                                    onClick={e => doDeleteDetailItem(e, x, i)}
                                                >
                                                    <span>🗑️</span>
                                                    <span>حذف</span>
                                                </button>
                                            </div>

                                            <div className="row g-2">
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">نام</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm bg-white"
                                                        disabled
                                                        value={x.name || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="name" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">نام خانوادگی</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm bg-white"
                                                        disabled
                                                        value={x.family || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="family" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">نام پدر</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm bg-white"
                                                        disabled
                                                        value={x.fatherName || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="fatherName" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">شماره شناسنامه</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm bg-white font-monospace"
                                                        disabled
                                                        value={x.code || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="code" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">کد ملی</label>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm bg-white font-monospace"
                                                        disabled
                                                        value={x.codeMeli || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="codeMeli" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">محل صدور</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm bg-white"
                                                        disabled
                                                        value={x.placeBirthName || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="placeBirthName" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">تاریخ تولد</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm bg-white font-monospace"
                                                        disabled
                                                        value={x.birthDay || ""}
                                                        //onChange={e => http.handleChange(e, form, setForm)}
                                                        name="birthDay" 
                                                    />
                                                </div>
                                                <div className="col-6 col-md-3">
                                                    <label className="form-label small text-muted mb-1">نسبت</label>
                                                    <select
                                                        className="form-select form-select-sm bg-white"
                                                        disabled
                                                        value={x.nesbat ?? ""}
                                                        //onChange={e => http.handleChange(e, formDetail, setFormDetail)}
                                                        name="nesbat" 
                                                    >
                                                        <option value={0}>مادر</option>
                                                        <option value={1}>پدر</option>
                                                        <option value={2}>فرزند</option>
                                                        <option value={3}>همسر</option>
                                                        <option value={4}>سایر</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center p-4 border border-dashed rounded-3 bg-light text-muted">
                                    <span className="fs-3 d-block mb-1">👥</span>
                                    <span>هنوز فرد تحت تکفلی اضافه نشده است. در صورت نیاز از دکمه «افزودن فرد جدید» استفاده فرمایید.</span>
                                </div>
                            )}
                        </div>

                        {/* دکمه ثبت نهایی و انتقال به بانک */}
                        <div className="mt-4 pt-3 border-top">
                            <button
                                type="button"
                                disabled={isPosting || isLoadingSetting || isLoading}
                                className="btn btn-success btn-lg w-100 py-3 rounded-3 shadow-sm d-flex align-items-center justify-content-center gap-2"
                                onClick={doPostFinall}
                            >
                                {isPosting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span>در حال انتقال به درگاه بانک...</span>
                                    </>
                                ) : (
                                    <>
                                        <span className="fw-bold">تایید نهایی و پرداخت حق بیمه</span>
                                        <span aria-hidden="true">💳 ➜</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* لینک بازگشت به داشبورد */}
                <div className="text-center mb-4">
                    <Link 
                        to="/main" 
                        className="btn btn-outline-secondary rounded-pill px-4 py-2 d-inline-flex align-items-center gap-2 text-decoration-none shadow-sm"
                    >
                        <img 
                            src={logoNoronCar} 
                            className="rounded-circle shadow-sm" 
                            style={{ width: "24px", height: "24px", objectFit: "contain" }}
                            alt="بازگشت" 
                        />
                        <span className="fw-semibold">بازگشت به صفحه اصلی</span>
                        <span aria-hidden="true">↩️</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}
